import ToggleCommissionDistributorPaid from "./toggle-commission-supplier-paid.modal";

const Modal = { ToggleCommissionDistributorPaid };

export default Modal;
